module.exports = __webpack_public_path__ + "static/dark-logo-25-ec3c444f0e7649e1db6fd2e8242972c2.png";